import { createSlice } from '@reduxjs/toolkit'

export const dpesSlice = createSlice({
    name: 'dpeRedux',
    initialState: {
        dpes: undefined,
    },
    reducers: {
        setDpesRedux: (state, action) => {
            state.dpes = action.payload;
        },
    },
})

export const { setDpesRedux } = dpesSlice.actions;

export const getDpesRedux = (state) => state.dpeRedux.dpes;

export default dpesSlice.reducer